import { 
  setGlobalDA, 
  setGlobalDAStatus, 
  setGlobalDepotName, 
  setGlobalOrderFrom, 
  setGlobalOrderFromReport, 
  setGlobalOrderStatus, 
  setGlobalTrip, 
  setGlobalTripStatus 
} from "../store/reducer/globalMultipleSearchSelect.reducer"

export const resetGlobalMSSValue = (dispatch) => {
  dispatch(setGlobalOrderFrom([]));
  dispatch(setGlobalOrderFromReport([]));
  dispatch(setGlobalDepotName([]));
  dispatch(setGlobalDAStatus([]));
  dispatch(setGlobalDA([]));
  dispatch(setGlobalTripStatus([]));
  dispatch(setGlobalTrip([]));
  dispatch(setGlobalOrderStatus([]));
}